module.exports = __webpack_public_path__ + "static/img/1692694720272.044cfb63.jpg";